module.exports = __webpack_public_path__ + "img/CICADA-logo-color.71d6aa1.svg";